var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M309-608a3,3,0,0,1,3,3h0v1h4a1,1,0,0,1,.993.883L317-603a1,1,0,0,1-1,1h-1v13a3,3,0,0,1-2.824,2.995L312-586H302a3,3,0,0,1-3-3h0v-13h-1a1,1,0,0,1-.993-.883L297-603a1,1,0,0,1,1-1h4v-1a3,3,0,0,1,2.824-2.995L305-608Zm4,6H301v13a1,1,0,0,0,.883.993L302-588h10a1,1,0,0,0,1-1h0Zm-8,3a1,1,0,0,1,1,1h0v6a1,1,0,0,1-1,1,1,1,0,0,1-1-1h0v-6A1,1,0,0,1,305-599Zm4,0a1,1,0,0,1,1,1h0v6a1,1,0,0,1-1,1,1,1,0,0,1-1-1h0v-6A1,1,0,0,1,309-599Zm0-7h-4a1,1,0,0,0-1,1h0v1h6v-1a1,1,0,0,0-.883-.993Z",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2059",
    "data-name": "Rectangle 2059",
    width: 22,
    height: 24,
    transform: "translate(296 -609)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M297-586h20v-22H297Z",
    fill: "#00142e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3197",
    "data-name": "Group 3197",
    transform: "translate(-297 608)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3196",
    "data-name": "Group 3196",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3195",
    "data-name": "Group 3195",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3194",
    "data-name": "Group 3194",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M296-609h22v24H296Z",
    fill: "#00142e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M296-609h22v24H296Z",
    fill: "#00142e"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c75b3ac6.svg";
export { ForwardRef as ReactComponent };